<template>
  <div class="cvs-main" @click="hiddenCvItemHandlerDialog()">
    <layouts>
      <template v-slot:sidebar>
        <!-- 骨架图 slidebar -->
        <skeleton-cvs-slidebar v-if="!skeletonSlidebarVisible" />
        <comp-sidebar v-if="skeletonSlidebarVisible"
                      :banner="banner"
                      :onlineCvData="onlineCv"
                      :isUpdated="isUpdated"
                      :isPerfect="isPerfect"
                      :isStudent="is_student"
                      :cvInvisibileVisible="cvInvisibileVisible"
                      :createOnlineCvVisible="createOnlineCvVisible"
                      :onlineCvModuleVisible="onlineCvModuleVisible"
                      :notSelectedMentorOrders="notSelectedMentorOrders"
                      :skeletonContentTopVisible="skeletonContentTopVisible"
                      :userLock="userLock"
                      @changeConfirmState="changeConfirmState"
                      @triggleCvUpdatedFunc="getData('second')"
                      @triggerUpdateOnlineCvFunc="triggerUpdateOnlineCvFunc"
                      @triggerCreateOnlineCvFunc="triggerCreateOnlineCvFunc"
                      @triggerToggleOnlineCvFunc="triggerToggleOnlineCvFunc"
                      @jobscanClickFunc="jobscanClickFunc"
                      @planClickFunc="planClickFunc"
                      @triggerShowOnlineCvDetailFunc="triggerShowOnlineCvDetailFunc" />
        <!-- <sidebar/> -->
      </template>
      <template v-slot:sidebarContent>
        <!-- <div class="banner-carousel" v-if="banner.image">
          <img :src="banner.image" alt="" v-if="!banner.link">
          <a v-else :href="banner.link" target="_blank">
            <img :src="banner.image" alt="">
          </a>
        </div> -->
      </template>
      <template v-slot:content>

        <!-- <skeleton-no-cvs-content /> -->

        <template>

          <!-- 骨架图 content top -->
          <!-- <skeleton-cvs-content-top v-if="!skeletonContentTopVisible" /> -->

          <!-- 骨架图 content bottom -->
          <!-- <skeleton-cvs-content-bottom v-if="!skeletonContentBottomVisible" /> -->

          <template v-if="!skeletonSlidebarVisible">
            <skeleton-cvs-content-top />
            <skeleton-cvs-content-bottom />
          </template>

          <template v-else>

          <!-- 有简历 展示 -->
          <div v-if="cvs.length">

            <skeleton-cvs-content-top v-if="!skeletonContentTopVisible" />
            <!-- jobscan 和 职业规划 入口 -->
            <div class="entry-box">

              <!-- jobscan -->
              <!-- <div class="entry-item jobscan" @click="jobscanClickFunc()" data-growing-container data-growing-idx="301">

                <div class="entry-item-header">
                  <div>
                    <img class="entry-item-icon" src="https://files.wondercv.com/PC/cvs/resume_icon.png" alt="">
                    <h6 class="entry-item-title">简历分析报告</h6>
                  </div>
                  <button class="entry-item-btn" v-if="jobscanDataVisible">查看全部</button>
                  <button class="entry-item-btn" v-else>立即体验</button>
                </div>

                <div class="entry-item-content">
                  <img class="entry-item-image" src="https://files.wondercv.com/PC/cvs/resume_pattern.png" alt="">
                  <div class="entry-item-info score" v-if="jobscanDataVisible">
                    <div><span>{{ jobscanData.total_score }}</span>分</div>
                    <p>通过智能检查分析你的简历得分为{{ jobscanData.total_score }}分</p>
                  </div>
                  <div class="entry-item-info" v-else>
                    <span>暂无报告</span>
                    <p>AI 智能优化简历，精准匹配热门职位</p>
                  </div>
                </div>

              </div> -->

              <!-- 职业规划 -->
              <!-- <div class="entry-item plan" @click="planClickFunc()" data-growing-container data-growing-idx="302">

                <div class="entry-item-header">
                  <div>
                    <img class="entry-item-icon" src="https://files.wondercv.com/PC/cvs/planning_icon.png" alt="">
                    <h6 class="entry-item-title">专属求职规划</h6>
                  </div>
                  <button class="entry-item-btn" v-if="planDataVisible">查看全部</button>
                  <button class="entry-item-btn" v-else>立即体验</button>
                </div>

                <div class="entry-item-content">
                  <img class="entry-item-image" src="https://files.wondercv.com/PC/cvs/planning_pattern.png" alt="">
                  <div class="entry-item-info name" v-if="planDataVisible">
                    <span>{{ planData[0].profession_name }}</span>
                    <p>是通过求职大数据为你匹配的最佳职位</p>
                  </div>
                  <div class="entry-item-info" v-else>
                    <span>暂未体验</span>
                    <p>大数据帮你规划最适合的职业发展路径</p>
                  </div>
                </div>

              </div> -->
              <div v-for="(item, index) in headerBanners" :key="index" class="header-banner-item" @click="handleHeaderBannerClick(item)">
                <img :src="item.image" alt="">
              </div>

            </div>

            <!-- 显示跳转到开启隐私按钮条件： -->
            <!-- 1. 隐私设置关闭了 -->
            <!-- 2. 有可以生成在线简历的简历 -->
            <!-- <div class="title setting" v-if="cv_invisibile && getisOnlineCv()">
              <div class="text"><i class="iconfont iconeye-off"></i>简历已下线，无法获得推荐机会</div>
              <div class="setting-btn" style="line-height: 32px">
                <button @click="upSetting">试试推荐</button>
              </div>
            </div> -->

            <!-- 创建在线简历 -->

            <!-- 显示创建在线简历入口条件： -->
            <!-- 1. 隐私设置没有关闭 【!cv_invisibile】 -->
            <!-- 2. 有满足生成在线简历条件的简历（中文简历、可编辑、不为导师） 【getisOnlineCv()】 -->
            <!-- 3. 接口返回的数据 res.data.resume 没有有值 【onlineCv】 -->
            <!-- 4. 接口返回的数据 res.data.resume.resume 没有有值 【onlineCv.resume】 -->
            <!-- <div class="title setting" v-if="!cv_invisibile && getisOnlineCv() && !(onlineCv && onlineCv.resume)">
              <div class="text"><i class="iconfont iconshengji"></i>开启智能推荐，让工作主动找你</div>
              <div class="setting-btn">
                <button @click="createdSettingCv('new')">点击开启</button>
              </div>
            </div> -->

            <!-- 内容展示组件 -->
            <div class="content" style="overflow: hidden;" v-if="(isLoaderOnline && !cv_invisibile && onlineCv.resume && onlineCv.resume.info) || cvs.length">

              <!-- 显示在线简历模块条件：
              1. 获取在线简历接口完成 【isLoaderOnline】
              2. 隐私设置没有关闭 【!cv_invisibile】
              3. 接口返回的数据 res.data.resume.resume 有值 【onlineCv.resume】
              4. 接口返回的数据 res.data.resume.resume.info 有值 【onlineCv.resume.info】
              5. 有满足生成在线简历条件的简历（中文简历、可编辑、不为导师） 【getisOnlineCv()】 -->
              <!-- <div class="on-line margin-b-24" v-if="isLoaderOnline && !cv_invisibile && onlineCv.resume && onlineCv.resume.info && getisOnlineCv()">
                <div class="title margin-b-1">
                  <div class="title-left">
                    简历推荐中 <span>{{!isUpdated ? '根据隐私设置推荐给名企 HR 和内推机会' : '简历已更新，是否更新推荐中的简历'}}</span>
                  </div>
                  <a class="title-setting" href="/account/users?index=2" target="_blank">
                    隐私设置<img src="https://files.wondercv.com/pc-cvs/%E5%BD%A2%E7%8A%B6%E7%BB%93%E5%90%88%402x.png" alt="">
                  </a>
                </div>
                <on-line-item
                  :isPerfect="isPerfect"
                  :data="onlineCv"
                  :isUpdated="isUpdated"
                  :is_student="is_student"
                  @updated="upSetting"
                  @click="uplineClick"
                  @perfect="perfect"/>
              </div> -->


              <!-- <div class="drafts margin-b-24">
                <div style="background: #fff;margin-bottom: -54px;z-index: 2;position: relative;" v-if="!cvsData.mentor_order_url && isShowMember">
                  <div class="title setting hint">
                    <div class="text"><i class="iconfont iconcuowu"></i>免费版可编辑 1 份中文简历，1 份英文简历，升级会员可创建多份简历</div>
                    <div class="setting-btn">
                      <button @click="member">升级会员</button>
                    </div>
                  </div>
                </div>
                <div :style="{marginBottom: cvs.length ? '-54px' : '-74px' }" style="background: #fff;z-index: 2;position: relative;" v-if="notSelectedMentorOrders.count">
                  <div class="title setting hint">
                    <div class="text"><i class="iconfont iconcuowu"></i>提示：简历修改服务信息未完善，完善后才能分配导师</div>
                    <div class="setting-btn">
                      <button @click="perfectUrl()">立即完善</button>
                    </div>
                  </div>
                </div>
                <div class="title margin-b-1" v-if="cvs.length">
                  我的简历 <span>共有 {{cvs.length || 0}} 份简历</span>
                </div>
                <div :class="['drafts-list']" v-if="cvs.length">
                  <cv-item
                    v-for="item in (cvsShow ? cvs.length : 1)"
                    :key="cvs[item - 1].token"
                    :data="cvs[item - 1]"
                    @changeConfirmState="changeConfirmState"
                    @updated="getData"
                    @download="download(cvs[item - 1])"/>
                </div>
                <div class="drafts-more" v-if="cvs.length > 1">
                  <span :class="[cvsShow ? 'active' : '', cvsShow ? 'blue' : '']" @click="cvsShow = !cvsShow">{{cvsShow ? '收起简历' : '展开全部'}}<i class="iconfont iconchevron-down"></i></span>
                </div>
              </div> -->

              <!-- <div class="recruit">
                <a v-for="item in recruitBanner" :key="item.image" class="recruit-item cursor_p" :href="item.link">
                  <img :src="item.image" alt="">
                  <div class="recruit-item-msg">{{item.title || 'test'}}</div>
                </a>
                <a class="recruit-entrance cursor_p" href="/campus_recruiting/user_show">
                  <img src="https://files.wondercv.com/PC/cvs/campus%20recruitment.png" alt="">
                </a>
              </div> -->

              <skeleton-cvs-content-bottom v-if="!skeletonContentBottomVisible" />
              <div class="cvs-job" v-if="skeletonContentBottomVisible">

                <div class="cvs-job-title">
                 <div class="cvs-job-title-left">
                    <span :class="{'active': cvsContentTabType === 'campus'}" v-if="is_student" @click="toggleCvsContentTabTypeFunc('campus')">校招网申</span>
                    <span :class="{'active': cvsContentTabType === 'job'}" @click="toggleCvsContentTabTypeFunc('job')">推荐职位</span>
                    <span :class="{'active': cvsContentTabType === 'invite', 'new': !!newHrInviteTotalCount}" @click="toggleCvsContentTabTypeFunc('invite')">HR 邀约
                      <!-- <i>{{ newHrInviteTotalCount ? newHrInviteTotalCount : `(${hrInviteTotalCount})` }}</i> -->
                    </span>
                 </div>
                 <div class="cvs-job-title-right" v-if="cvsContentTabType !== 'invite'" @click="toJobs" data-growing-container data-growing-idx="411">
                   <span>{{ cvsContentTabType === 'campus' ? '更多校招' : '更多职位' }}</span><i class="iconfont iconchevron-right"></i>
                 </div>
                </div>

                <div v-loading="getJobLoading">
                  <!-- 校招网申 -->
                  <div v-show="cvsContentTabType === 'campus'">
                    <comp-category class="campus-list"
                                  :origin="'cvs'"
                                  :width="'373px'"
                                  :showCardCount="6"
                                  :cardList="campusCardList" />
                  </div>

                  <!-- 推荐职位 -->
                  <div v-show="cvsContentTabType === 'job'">

                    <div class="cvs-job-setting" v-if="!isUpdateJobs">
                      <template v-if="!is_intention">
                        <p class="setting-desc">你还未填写求职意向，设置后将为你推荐更多职位</p><span class="setting-button" @click="intentionShow = true">立即设置</span>
                      </template>
                      <template  v-else-if="is_intention && jobs.length === 6 && is_one_intention">
                        <p class="setting-desc">根据你的求职意向{{intentionText ? `“${intentionText}”` : ''}}为你推荐以下职位</p><span class="setting-button" @click="intentionShow = true">立即修改</span>
                      </template>
                      <template v-else>
                        <p class="setting-desc">根据你的简历为你推荐以下职位，修改求职意向可匹配更多热门职位</p><span class="setting-button" @click="intentionShow = true">立即修改</span>
                      </template>
                    </div>

                    <div class="cvs-job-list" v-if="!isUpdateJobs">
                      <itemCard
                        origin="cvs"
                        width="373px"
                        :border="true"
                        class="item-card"
                        v-for="(item, index) in jobs"
                        :key="index"
                        :data="item"
                        :show="!(jobs.length === 6 && is_all_intention)"/>
                    </div>

                    <skeleton-cvs-content-bottom :hiddenBtn="true" v-if="isUpdateJobs" />

                  </div>

                  <!-- HR 邀约 -->
                  <div v-show="cvsContentTabType === 'invite'">
                    <comp-inbox @editHrInviteTotalCount="editHrInviteTotalCount" :cvsContentTabType="cvsContentTabType" />
                  </div>
                </div>

                <!-- <skeleton :optivons="{moduleCount: 1, count: 1}" v-if="!isLoaderJobs" /> -->

                <!-- <button v-if="cvsContentTabType !== 'invite'" class="cvs-job-more" @click="toJobs" data-growing-title="recommend-more" data-gio-imp-track="recommend" data-gio-track-type="more">查看更多职位</button> -->
                <button v-if="cvsContentTabType !== 'invite'" class="cvs-job-more" @click="toJobs('bottom')" data-growing-container data-growing-idx="311">{{ cvsContentTabType === 'campus' ? '查看更多校招' : '查看更多职位' }}</button>

              </div>

              <!-- <cvs-template v-if="!cvs.length"/> -->
            </div>

          </div>

          <!-- 没有简历 展示 -->
          <div v-else>

            <skeleton-cvs-content-top v-if="!skeletonNoCvContentVisible" />
            <skeleton-cvs-content-bottom v-if="!skeletonNoCvContentVisible" />

            <!-- <div style="background: #fff;margin-bottom: -54px;z-index: 2;position: relative;" v-if="!cvsData.mentor_order_url && isShowMember">
              <div class="title setting hint">
                <div class="text"><i class="iconfont iconcuowu"></i>免费版可编辑 1 份中文简历，1 份英文简历，升级会员可创建多份简历</div>
                <div class="setting-btn">
                  <button @click="member">升级会员</button>
                </div>
              </div>
            </div> -->
            <!-- <div style="background: #fff;margin-bottom: -54px;z-index: 2;position: relative;" v-if="notSelectedMentorOrders.count">
              <div class="title setting hint">
                <div class="text"><i class="iconfont iconcuowu"></i>提示：简历修改服务信息未完善，完善后才能分配导师</div>
                <div class="setting-btn">
                  <button @click="perfectUrl()">立即完善</button>
                </div>
              </div>
            </div> -->
            <cvs-template v-if="skeletonNoCvContentVisible"
                          :noCvSuggestedTemplateList="noCvSuggestedTemplateList"
                          :noCvSampleTemplateList="noCvSampleTemplateList"/>
          </div>

          </template>

          <div style="padding-top: 56px;"></div>

        </template>
      </template>
      <!-- <template v-slot:content v-else>
        <skeleton/>
      </template> -->
    </layouts>
    <div class="popup-banner-container" v-if="popupBanner.image && showPopupBanner && skeletonSlidebarVisible">
      <img :src="popupBanner.image" alt="" @click="toBannerLink">
      <div class="close-btn" @click="showPopupBanner = false" />
    </div>
    <wx v-if="isLoaderCv"/>
    <union-members-popup
      v-if="isLoaderCv"
      icon="https://logo.wondercv.com/banners/UrVUWjxruMOlzBq.png"
      storageKey="unionMemberTipsIndex"
    ></union-members-popup>
    <alert ref="recommendCvAlert" :alertData="alertData" @close="alertClose" @changeDownloadAppState="changeDownloadAppState" :updatedType="updatedType" />
    <cv-resume v-if="showCvResume"
               :data="onlineCv"
               :userIdentify="userIdentify"
               :key="onlineCvDetailKey"
               :isUpdated="isUpdated"
               :isPerfect="isPerfect"
               @close="showCvResume = false"
               @triggerUpdateOnlineCvFunc="triggerUpdateOnlineCvFunc"
               @triggerSetIntentionDialogFunc="triggerSetIntentionDialogFunc" />
    <!-- 求职意向弹框 -->
    <intention :show="intentionShow" @clone="intentionShow = false" @update="updateJobs"/>
    <download-app-by-resume class="download-app-chat" :dialog-state="downloadAppState" @handleClose="changeDownloadAppState"/>
    <BindPhone :state="bindPhoneState" @close="handleCancel" @success="handleSuccess" v-if="bindPhoneState" />
    <w-confirm class="confirm-content" :dialog-state="confirmState" :dialog-content-data="dialogContentData" @handleClose="changeConfirmState" />
    <!-- 职业规划 选择简历弹窗 -->
    <comp-plan-cv-select @close="planSelectVisible = false" v-if="planSelectVisible"/>
    <forbidden-modal v-if="userLock" :feedbackStatus="feedbackStatus"></forbidden-modal>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';

import api from '@/api';
import moment from 'moment'
import { get_tUser, dealSignatrue, routerTo, auth, displayBannerSaveHistory } from '@/assets/js/util';

import cvNavbar from '@/components/base/navbar';
import layouts from '@/components/base/layouts';
import cvItem from './components/item';
import BindPhone from './components/BindPhone'
import onLineItem from './components/onLineItem';
import sidebar from '@/components/base/sidebar';
import cvsTemplate from './components/cvsTemplate';
import job from './components/job';
import skeleton from '@/components/base/skeleton';
import wx from './components/wx';
import UnionMembersPopup from './components/unionMembersPopup'
import itemCard from '@/views/jobs/components/itemCard';
import intention from '@/components/jobs/intention';

import CompCategory from '@/views/jobs/components/category'
import CompSidebar from '@/components/page/cvs/sidebar'
import CompInbox from '@/components/page/cvs/inbox'
import CompPlanCvSelect from '@/views/planning/components/planning-resume-select'

import SkeletonCvsSlidebar from '@/components/skeleton/cvs/cvs-slidebar'
import SkeletonCvsContentTop from '@/components/skeleton/cvs/cvs-content-top'
import SkeletonCvsContentBottom from '@/components/skeleton/cvs/cvs-content-bottom'

import cvResume from './components/cv';

import conditions from '@/assets/json/conditions';
import alert from './components/alert';
import downloadjs from 'downloadjs';
import downloadAppByResume from '../editorResume/cvsEditor/components/downloadAppByResume'
import axios from 'axios';
import Cookies from 'js-cookie'
import Template from '../../components/resume/template.vue';
import WConfirm from '../../components/base/WConfirm'
import ForbiddenModal from './components/forbiddenModal.vue';

let mainLoading = null;
export default {
  name: 'Cvs',
  components: {
    skeleton,
    cvNavbar,
    cvItem,
    onLineItem,
    sidebar,
    layouts,
    alert,
    cvsTemplate,
    cvResume,
    job,
    wx,
    UnionMembersPopup,
    itemCard,
    intention,
    downloadAppByResume,
    BindPhone,
    Template,
    WConfirm,
    CompCategory, // 校招卡片 组件
    CompSidebar, // cvs 左侧边栏
    CompInbox, // hr 邀约组件
    CompPlanCvSelect, // 职业规划 选择简历弹窗 组件
    SkeletonCvsSlidebar, // slidebar 骨架图
    SkeletonCvsContentTop, // content top 骨架图
    SkeletonCvsContentBottom, // content bottom 骨架图
    ForbiddenModal
  },
  data() {
    return {
      _c_t: '',
      onlineCv: {}, // 在线简历
      cv_invisibile: false, // 在线简历私密度
      isUpdated: false, // 是否有最近更新的简历
      newestCvToken: null, // 最近更新的简历 token
      updateLoading: false, //更新简历中
      updated_at: '',
      showCvResume: false,
      is_student: false, // 学生
      is_intention: false, // 是否设置求职意向
      is_all_intention: true, // 推荐的职位是否全为 根据求职意向推荐
      is_one_intention: false, // 推荐的职位是否至少有一个 根据求职意向推荐
      intentionShow: false, // 求职意向弹框
      alertData: {
        show: false,
        type: ''
      },
      updatedType: 'new',
      isShow: false, // 是否显示
      isLoader: false,
      isShowMember: false, // 显示续费
      isShowPerfect: false, // 显示完善辅导简历
      isDownloadCv: false, // 是否正在下载简历
      cvsShow: false, // 展示更多简历
      userLock: false,
      feedbackStatus: '',

      // 推荐职位
      jobs: [], // 推荐职位数据
      jobsTotal: 0, // 推荐职位总条数

      isLoaderOnline: false, // 是否获取完在线简历
      isLoaderCv: false, // 是否获取完简历列表
      isLoaderJobs: false, // 是否获取完职位卡片
      isLoaderCampus: false, // 是否获取完校招卡片

      isLoaderJobscan: false, // 是否获取完 jobscan 数据
      isLoaderPlan: false, // 是否获取完 plan 数据

      isLoaderNoCvContent: false, // 是否获取完没有简历时 数据

      isUpdateJobs: false, // 是否更新职位列表

      banner: {},
      popupBanner: {},     // 浮窗 banner 数据
      headerBanners: [],
      showPopupBanner: true,    // 浮窗 banner 显示开关
      isPerfect: false, // 是否需要完善
      notSelectedMentorOrders:{
        count: 0
      },
      downloadAppState: false,
      intentionText: null, // cvs jobs 根据求职意向推荐职位的求职意向值
      isBindPhone: false,     // 是否绑定了手机号
      bindPhoneState: false,   // 是否显示绑定手机号弹窗
      onlineCvIndex: -1, //推荐中简历对应简历列表的位置
      cvIsRecommend: false,
      confirmState: false,
      dialogContentData: {
        title: '简历份数已达上限',
        content: '免费版仅可编辑一份简历，现在升级会员即可在线编辑全部草稿简历～',
        confirmText: '升级会员',
        confirmFn: () => {
          routerTo('/account/users/buy_member', '_blank')
        },
        cancelText: '下载简历',
        cancelFn: () => {
          // this.confirmState = false
        }
      },
      lastEducationTime: '',
      recruitBanner: [],
      cvsContentTabType: null, // cvs 内容区域 tab 类型 可能的值： 1. campus 校招网申 2. job 职位 3. invite 邀约
      hrInviteTotalCount: 0, // hr 邀约总数
      newHrInviteTotalCount: 0, // hr 新的邀约数
      jobscanDataVisible: false, // 简历是否有 jobscan 数据
      jobscanData: {}, // 简历 jobscan 数据
      planSelectVisible: false, // 职业规划 选件简历弹窗 visible
      planDataVisible: false, // 简历是否有 职业规划 数据
      planData: [], // 简历 职业规划 数据
      campusCardList: [], // 校招日历卡片数据列表
      noCvSuggestedTemplateList: [], // 没有简历时推荐模板
      noCvSampleTemplateList: [], // 没有简历时大牛模板
      onlineCvDetailKey: 1001, // 在线简历预览组件 key 值（为了控制该组件渲染）
      isLoadingUpdateOnlineCv: false, // 是否正在更新在线简历
      userIdentify: null,
      getJobLoading: false, //是否请求中
      getJobEnd: false, //是否请求结束
    };
  },
  computed: {
    ...mapState('cvs', ['downloadCv', 'cvsData']),
    ...mapState('cv', ['cvs',]),
    ...mapState('me', ['personInfo']),
    ...mapState('jobs', ['intention', 'cities', 'userIntentions']),

    tabActiveClass () {
      if (this.is_student) {
        if (this.cvsContentTabType === 'campus') return 'tab1'
        if (this.cvsContentTabType === 'job') return 'tab2'
        if (this.cvsContentTabType === 'invite') return 'tab3'
      } else {
        if (this.cvsContentTabType === 'job') return 'tab1'
        if (this.cvsContentTabType === 'invite') return 'tab2'
      }
    },
    cvAccountToken () {
      let _t = Cookies.get('_t')
      if (_t) {
        let tokenPayload = _t && JSON.parse(window.atob(_t.split('.')[1]))
        return tokenPayload.User.c_t
      }
    },
    // 三个条件满足其一就弹窗搜索信息
    showAccountMessageBox() {
      let messageBoxFlag = localStorage.getItem('messageBoxFlag');
      return (this.isBeforeEducation || this.isUpdateCvTime || this.identityOrIntention) && (!messageBoxFlag || Math.floor(new Date().getTime() / 1000) - parseInt(messageBoxFlag) > 15811200)
    },
    // 学生身份 && 最近一段教育的毕业时间早于当前
    isBeforeEducation() {
      let date = new Date(this.lastEducationTime).getTime()
      let now = new Date().getTime()
      return this.is_student && date < now
    },
    // 是否当前时间 - 简历最近更新时间 > 1年
    // 更新时间 + 1年 < 当前时间
    isUpdateCvTime() {
      if (this.cvs.length > 0) {
        let arr = this.cvs[0].update_time.split('-')
        arr[0] = parseInt(arr[0]) + 1
        let cvUpdateTime = arr.join(',')
        return moment(cvUpdateTime) < moment()
      }
      return false
    },
    // 身份或者求职意向是否为空
    identityOrIntention() {
      return !this.is_intention
    },
    /**
     * 显示跳转到开启隐私按钮条件：
     * 1. 隐私设置关闭了
     * 2. 有可以生成在线简历的简历
     */
    cvInvisibileVisible () {
      return this.cv_invisibile && this.getisOnlineCv()
    },
    /**
     * 显示创建在线简历入口条件：
     * 1. 隐私设置没有关闭 【!cv_invisibile】
     * 2. 有满足生成在线简历条件的简历（中文简历、可编辑、不为导师） 【getisOnlineCv()】
     * 3. 接口返回的数据 res.data.resume 没有有值 【onlineCv】
     * 4. 接口返回的数据 res.data.resume.resume 没有有值 【onlineCv.resume】
     */
    createOnlineCvVisible () {
      return !this.cv_invisibile && this.getisOnlineCv() && !(this.onlineCv && this.onlineCv.resume)
    },
    /**
     * 显示在线简历模块条件：
     * 1. 获取在线简历接口完成 【isLoaderOnline】
     * 2. 隐私设置没有关闭 【!cv_invisibile】
     * 3. 接口返回的数据 res.data.resume.resume 有值 【onlineCv.resume】
     * 4. 接口返回的数据 res.data.resume.resume.info 有值 【onlineCv.resume.info】
     * 5. 有满足生成在线简历条件的简历（中文简历、可编辑、不为导师） 【getisOnlineCv()】
    */
    onlineCvModuleVisible () {
      return !this.cv_invisibile && this.onlineCv.resume && this.onlineCv.resume.info && this.getisOnlineCv()
    },
    // 是否显示 左侧菜单骨架图
    skeletonSlidebarVisible () {
      return this.isLoaderCv
    },
    // 是否显示 内容区域 top 单骨架图
    skeletonContentTopVisible () {
      return this.isLoaderJobscan && this.isLoaderPlan
    },
    // 是否显示 内容区域 bottom 骨架图
    skeletonContentBottomVisible () {
      return true
      // return this.isLoaderJobs && this.isLoaderCampus
    },
    // 是否显示 无简历内容区域 骨架图
    skeletonNoCvContentVisible () {
      return this.isLoaderNoCvContent
    }
  },
  watch: {
    // cvs: {
    //   deep: true,
    //   immediate: true,
    //   handler: async function (cvs) {
    //
    //   }
    // },
    personInfo: {
      deep: true,
      immediate: true,
      handler: async function (personInfo) {
        // let { membership_expired_at } = personInfo;
        // let time = new Date(membership_expired_at).getTime();
        // if (time > 0 && Date.now() - 1000 * 60 * 60 * 24 * 7 < 0) {
        //   this.isShowMember = true;
        // }
        // else {
        //   this.isShowMember = false;
        // }
      }
    }
  },
  async created() {
    // this.handleCheckUserLock()
    // 判断是否从简历下载页跳转到此页面
    let origin = this.$route.query.origin;
    let type = this.$route.query.type;
    if (origin) {
      this.createdSettingCv('new')
    }
    if (type === 'onlineCvPreview') {
      this.triggerShowOnlineCvDetailFunc()
    }
    this._c_t = get_tUser().c_t || '';
    auth();
    this.getLastEducationTime()
    this.$store.dispatch('app/setNavbarAction', '我的简历');
    this.$store.dispatch('app/setSidebar', '我的简历');
    mainLoading = this.$message({
      message: '正在加载',
      iconClass: 'el-icon-loading',
      duration: 0
    });
    if (!this._c_t) return false;

    // 获取右侧内容区域数据
    this.initCvsContentData()
    // 获取 banner
    this.getBanner()
    // 获取用户身份
    this.getIdentifyInfo()



    // 获取 草稿简历列表
    await this.getData();
    // 推荐职位（获取完在线简历，再拿在线简历 token 调职位推荐）
    this.setEditCvAfterMemberOver()

    // 求职意向
    // if (true || !res.intention) {
    //   this.alertData = {
    //     show: true,
    //     type: 'identity'
    //   };
    //   return false;
    // }
    // 判断是否有完善信息的导师订单
    this.getNotSelectedMentorOrders();
    // // 推荐职位
    // await this.getRecommendList()
    // // 校招卡片
    // await this.getCampusCardList()
    // // 获取无简历时数据
    // await this.getNoCvData()
    // 求职意向
    this.getIntention();
    // this.isLoaderCv = true;

    // inbox页跳转到cvs页，触发 设置在线简历
    if (this.$route.params.from_inbox || this.$route.query.needRecommend) {
      this.createdSettingCv('new')
    }
    //判断是不是有重定向页面
    let r_b_t = Cookies.get('_r_b_t')
    r_b_t = decodeURIComponent(r_b_t);
    if((r_b_t && !r_b_t.includes('wondercv')) || r_b_t.includes('m.wondercv')){
      r_b_t = '';
    }
    // 返回的url要进行解码再跳转(如果r_b_t等于当前路由，就不进行跳转)
    if(r_b_t){
      let { hostname } = window.location
      let url = window.location.hostname;
      let domain = url.replace(/.*?(\.wondercv.(cn|com))/gim, '$1');
      Cookies.remove('_r_b_t', {domain});
      if (window.location.href == r_b_t || window.location.href.includes(r_b_t)){
        return
      }
      window.location.href = r_b_t
    }
  },
  async mounted () {
    // await api.jobs.getBanner({position: '26'}).then(res => {
    //   this.recruitBanner = res.data.slice(0, 3);
    // }).catch(console.log);

    try {
      let res = await api.me.getUserInfo(this._c_t);
      if (res.code !== 1000) {
        return false;
      }
      this.is_intention = res.data.intention
      this.is_student = res.data.is_student;
      if (this.is_student) {
        this.cvsContentTabType = 'campus'
      } else {
        this.cvsContentTabType = 'job'
      }
      if (!res.data.match) {
        // routerTo('/template_matches/new?id=current');
        return
      }
      // 获取推荐职位
      this.getRecommendList()
    } catch (e) {

    }

    // 开发本地测试用（开发完会删除）
    // this.alertData = {
    //   show: true,
    //   type: 'groups',
    //   groupToken: 'iTKbZjI',
    //   schoolName: '北京大学',
    //   schoolLogo: 'https://photo.wondercv.com/uploads/school_logo/image/96/48119cab-7c8a-40cd-8f5c-548780498890'
    // }
    // return

    let useTemplate = localStorage.getItem('useTemplate')
    let newAccount = localStorage.getItem('newAccount')
    if (useTemplate && newAccount) {
      localStorage.removeItem('useTemplate')
      // localStorage.removeItem('newAccount')
      routerTo(`/cvs/${useTemplate}/editor`)
      return
    }
    
    //cvs广告页弹框
    let res = await api.jobs.getBanner({ position: '72' })
    if (res.code === 1000) {
      const afterMinus = await displayBannerSaveHistory(res.data?.length, 'cvsbanner');
      if (afterMinus === 0 || afterMinus) {
        this.alertData = {
          show: true,
          type: 'cvsguanggao',
          image: res.data[afterMinus],
        }
      }
    }

    return console.log(res)
    // else if (newAccount) {
    //   localStorage.removeItem('newAccount')
    // }
    // 机构号弹窗（目前优先级最高）新用户注册完成首次进入CVS页面，如果注册流程填写的教育经历院校有机构号，则谈该弹窗
    try {
      let res = await api.account.getUserGroups()
      console.log('getUserGroups========>', res, newAccount)
      if (res.code === 1000) {
        if (newAccount) {
          localStorage.removeItem('newAccount')
          // this.alertData = {
          //   show: true,
          //   type: 'groups',
          //   groupToken: res.data.group_token,
          //   schoolName: res.data.school_name,
          //   schoolLogo: res.data.school_logo
          // }
          return
        }
      } else {
        if (newAccount) {
          localStorage.removeItem('newAccount')
        }
      }
    } catch (error) {
      console.log(error)
    }

    // 半年只弹一次弹窗
    if (this.showAccountMessageBox && this.is_student !== null) {
      this.intentionShow = true
      localStorage.removeItem('messageBoxFlag')
      localStorage.setItem('messageBoxFlag', Math.floor(new Date().getTime() / 1000))
    }
    // 去除微信登录之后绑定手机号弹窗
    // let bindPhoneTime = localStorage.getItem("cvsBindPhone")
    // 是扫码登录微信跳转过来的并且标识时限小于一小时的时候请求接口弹出绑定手机号弹窗 弹窗优先级：设置信息弹窗优先级 > 绑定手机号优先级 > 积分引流下载app
    // if (bindPhoneTime && bindPhoneTime - Math.floor(new Date().getTime() / 1000) < 60 * 60 && (!this.showAccountMessageBox && this.is_student !== null)) {
    //   try {
    //     let res = await api.auth.getBindMessage(this.cvAccountToken);
    //     if(res.code === 1000){
    //       console.log(res)
    //       //同步是否绑定手机号
    //       this.isBindPhone = res.data.phone_is_bound;
    //       if(!this.isBindPhone){
    //         // 简历数 > 0 时弹出绑定手机号弹窗
    //         if (res.data.active_cv_count > 0) {
    //           this.bindPhoneState = true
    //         }
    //       }
    //     }
    //   } catch (e) {
    //     console.error(e)
    //   }
    // } else if (bindPhoneTime && bindPhoneTime - Math.floor(new Date().getTime() / 1000) > 3600){
    //   localStorage.removeItem('cvsBindPhone')
    // }
    if (!this.intentionShow && !this.bindPhoneState) {
      try {
        let res = await api.auth.getBindMessage(this.cvAccountToken);
        if(res.code === 1000 && res.data.active_cv_count > 0 && !localStorage.getItem('showDrainage')){
          let ress = await api.me.getUserScore(this.cvAccountToken)
          if(ress.code == 1000 && ress.data.score > 0) {
            this.alertData = {
              show: true,
              type: 'drainage',
              score: ress.data.score
            }
            localStorage.setItem('showDrainage',true)
          }
        }
      } catch (e) {
        console.error(e)
      }
    }
  },
  methods: {
    ...mapMutations('cv', ['setCvActiveIndex']),
    async handleCheckUserLock() {
      try {
        const res = await api.account.getCip();
        if (res.code === 1000 && res.data.internal) return '内网环境';
        
        const { code, data } = await api.account.checkUserLock()
        this.userLock = code === 2003
        this.feedbackStatus = data?.feedback_status
        // if (code === 1000) {
        //   this.userLock = data?.feedback_status
        // }
      } catch (error) {
        console.log(error)
      }
    },
    toBannerLink() {
      if (!this.popupBanner.image || !this.popupBanner.link) return
      window.open(this.popupBanner.link)
    },

    handleHeaderBannerClick(data) {
      if (data.link) {
        window.open(data.link);
      }
    },

    // 获取用户身份
    async getIdentifyInfo () {
      try {
        let res = await api.cvsV2.getIdentifyInfo(this._c_t)
        if (res.code === 1000) {
          this.userIdentify = res.data.status
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 触发 修改求职意向弹窗显示
    triggerSetIntentionDialogFunc () {
      this.showCvResume = false
      this.intentionShow = true
    },
    // 更新在线简历（根据在线简历对应的这份草稿简历更新）
    async triggerUpdateOnlineCvFunc () {
      if (this.isLoadingUpdateOnlineCv) return
      this.isLoadingUpdateOnlineCv = true
      try {

        const onlineCvToken = this.onlineCv.resume.token

        this.updatedType = 'updated'

        // 判断简历是否完善
        let resCheck = await api.cvsV2.checkCv(onlineCvToken)
        // 已完善 直接更新
        if (resCheck.data.name_valid && resCheck.data.contact_valid && resCheck.data.gender_valid && resCheck.data.edu_valid && resCheck.data.work_valid) {
          let res = await api.cvsV2.createdOnlineCv({token: onlineCvToken})
          if (res.code === 1000) {
            this.$message.success('更新成功')
            this.updateLoading = false
            this.getData('second')
          } else {
            this.$message.error('更新失败')
          }
        // 没有完善则去完善
        } else {
          this.alertData = {
            show: true,
            type: 'onLine',
            showType: 'perfect',
            cv: {
              token: onlineCvToken
            }
          }
        }
        this.isLoadingUpdateOnlineCv = false
      } catch (error) {
        console.log(error)
        this.isLoadingUpdateOnlineCv = false
      }
    },
    // 切换在线简历
    async triggerToggleOnlineCvFunc () {
      try {
        this.updatedType = 'new'
        let res = await api.me.getUserInfo(get_tUser().c_t)
        if (res.code !== 1000) {
          this.$message.error('网络出错，请重试');
          return false;
        }
        // 求职意向
        if (!res.data.match) {
          this.alertData = {
            show: true,
            type: 'identity'
          }
          return false
        } else if (!res.data.intention) {
          this.alertData = {
            show: true,
            type: 'intention'
          }
          return false
        } else {
          // 弹出选择简历弹窗
          this.alertData = {
              show: true,
              type: 'onLine'
          }
        }

      } catch (error) {
        console.log(error)
      }
    },
    hiddenCvItemHandlerDialog () {
      this.setCvActiveIndex(null)
    },
    jobscanClickFunc () {
      if (this.jobscanDataVisible) {
        this.toJobscanDetailFunc()
      } else {
        this.toJobscanIndexFunc()
      }
    },
    planClickFunc () {
      if (this.planDataVisible) {
        this.toPlanDetailFunc()
      } else {
        this.toPlanIndexFunc()
      }
    },
    // 获取右侧内容区域数据
    initCvsContentData () {
      // 推荐职位
      // this.getRecommendList()
      // 校招卡片
      this.getCampusCardList()
      // 获取无简历时数据
      this.getNoCvData()
    },
    // 获取无简历时数据
    async getNoCvData () {
      try {
        this.isLoaderNoCvContent = false
        let res1 = await api.template.getSampleCvList()
        if (res1.code === 1000) {
          this.noCvSampleTemplateList = res1.data.sample_cvs || []
        }
        let res2 = await api.cvsV3.getCvsTemplate(this._c_t)
        if (res2.code === 1000) {
          this.noCvSuggestedTemplateList = res2.data.names || []
        }
        this.isLoaderNoCvContent = true
      } catch (error) {
        console.log(error)
        this.isLoaderNoCvContent = true
      }
    },
    // 去 职业规划 首页
    toPlanIndexFunc () {
      let list = this.cvs.filter(item => item.lang == 'cn')
      if(list.length > 1) {
        this.planSelectVisible = true
      } else if(list.length === 1) {
        api.planning.getExperience(list[0].token).then(res=>{
          if (res.code === 1000 && (res.data.edus.length > 0 || res.data.works.length > 0)){
            routerTo(`/planning/${list[0].token}/index`, '_blank')
          } else {
            this.$message.error(res.code === 1000 ? "请补充教育经历和工作经历后再进入" : res.message)
          }
        })
      } else if (list.length === 0 && this.cvs.length > 0){
        this.$message.error('创建中文简历后再进入')
      } else if (list.length === 0 && this.cvs.length === 0){
        this.$message.error('创建简历后再进入')
      }
    },
    // 去 职业规划 详情页
    toPlanDetailFunc () {
      window.open(`/planning/${this.newestCvToken}/index`, '_blank')
    },
    // 去 jobscan 首页
    toJobscanIndexFunc () {
      routerTo('/jobscan/index', '_blank')
    },
    // 去 jobscan 报告页
    toJobscanDetailFunc () {
       window.open(`/jobscan/results/${this.jobscanData.token}.html?form=cvs`,'_blank')
    },
    // 初始化 jobscan 和 职业规划入口
    initJobscanAndPlanEntry () {
      let token = this.newestCvToken
      if (!token) {
        this.isLoaderJobscan = true
        this.isLoaderPlan = true
        return
      }
      // 有简历 token 请求数据
      // 获取简历 jobscan 数据
      this.getJobscanData(token)
      // 获取简历 职业规划 数据
      this.getPlanData(token)

    },
    // 获取简历 jobscan 数据
    async getJobscanData (token) {
      try {
        this.isLoaderJobscan = false
        let res = await api.jobs.getBriefReport({cv_token: token})
        // 简历有 jobscan 报告
        if(res.code === 1000){
          this.jobscanDataVisible = true
          this.jobscanData = res.data
        // 简历无 jobscan 报告
        }else{
          this.jobscanDataVisible = false
          this.jobscanData = {}
        }
        this.isLoaderJobscan = true
      }catch (error) {
        console.log(error)
      }
    },
    // 获取简历 职业规划 数据
    async getPlanData (token) {
      try {
        this.isLoaderPlan = false
        let res = await api.planning.getPredictiveLevel({cv_token: token})
        if (res.code === 1000) {
          this.planData = res.data || []
          if (this.planData.length) {
            this.planDataVisible = true
          } else {
            this.planDataVisible = false
          }
        } else {
          this.planDataVisible = false
        }
        this.isLoaderPlan = true
      } catch (error) {
        console.log(error)
        this.planDataVisible = false
      }
    },
    // 获取校招卡片列表
    async getCampusCardList() {
      try {
        this.isLoaderCampus = false
        let params = {
          page:1,
          size: 9,
          info_type: '不限',
          type: 'recommend',
        }
        let res = await api.jobs.get_recruit_list(params)
        if(res.code === 1000){
          this.campusCardList = res.data.comp_recruit_infos || []
        }
        this.isLoaderCampus = true
      } catch (error) {
        console.log(error)
        this.isLoaderCampus = true
      }
     },
    // hr 邀约总数
    editHrInviteTotalCount (data) {
      this.hrInviteTotalCount = data.total
      this.newHrInviteTotalCount = data.newCount
    },
    // 切换 tab 类型
    toggleCvsContentTabTypeFunc (val) {
      this.cvsContentTabType = val

      if(val === 'job' && !this.getJobEnd){
        this.getJobLoading = true
        this.getRecommendList()
      }
    },
    // 触发 创建在线简历函数
    triggerCreateOnlineCvFunc () {
      if (this.createOnlineCvVisible) {
        this.createdSettingCv('new')
      } else if (this.cvInvisibileVisible) {
        this.upSetting()
      }
    },
    // 触发 显示在线简历详情函数
    triggerShowOnlineCvDetailFunc () {
      this.showCvResume = true
    },
    // 获取最后一段教育经历的毕业时间
    async getLastEducationTime() {
      try {
        let res = await api.cvsV2.getLastEducationTime(this.cvAccountToken)
        if (res.code === 1000) {
          this.lastEducationTime = res.data.end_at
        }
      } catch (e) {
        console.error(e)
      }
    },
    changeConfirmState(fn) {
      this.confirmState = !this.confirmState
      if (this.confirmState) {
        this.dialogContentData.cancelFn = () => {
          fn()
          this.confirmState = false
        }
      }
    },
    // 跳过绑定手机号回调
    handleCancel() {
      this.bindPhoneState = false
      localStorage.removeItem('cvsBindPhone')
    },
    // 绑定成功回调
    handleSuccess() {
      this.bindPhoneState = false
      localStorage.removeItem('cvsBindPhone')
    },
    // 修改求职意向后 更新职位列表
    updateJobs (data) {
      this.userIdentify = data.identify
      // 修改完身份后 需要判断是否显示校招 tab
      if (data.identify === 'student') {
        this.is_student = true
      } else {
        this.is_student = false
      }
      // 更新 职位列表
      this.updateRecommendList()
      // 求职意向
      this.getIntention();
      // 获取在线简历数据
      this.getOnlineCv()
    },
	  changeDownloadAppState () {
	  	this.downloadAppState = !this.downloadAppState
    },
    async getBanner() {
      // banner
      // let res = await api.jobs.getBanner({position: '2'});
      // if(res.data.length){
      //   this.banner = res.data[0] || {};
      // }

      Promise.all([
        api.jobs.getBanner({ position: '2' }),
        api.jobs.getBanner({ position: '92' }),
        api.jobs.getBanner({ position: '134' }),
        api.jobs.getBanner({ position: '135' })
      ]).then(([bannerRes, popupRes, res3, res4]) => {
          let headerBanners = []
          if (bannerRes.code === 1000 && bannerRes.data.length) {
            this.banner = bannerRes.data[0] || {};
          }
          if (popupRes.code === 1000 && popupRes.data.length) {
            this.popupBanner = popupRes.data[0] || {};
          }
          if (res3.code === 1000 && res3.data.length) {
            headerBanners.push(res3.data[0] || {})
          } 
          if (res4.code === 1000 && res4.data.length) {
            headerBanners.push(res4.data[0] || {})
          }
          this.headerBanners = headerBanners
        }).catch((error) => {
          console.log(error, 'error')
        })

    },
    async updateRecommendList () {
      try {
        this.isUpdateJobs = true
        let res = await api.recommend.cvsToJob({
          size: 6,
          page: 1,
          resume_token: this.onlineCv.resume ? this.onlineCv.resume.token : this.onlineCv.token ? this.onlineCv.token : null,
          is_pc: true
        });
        if (res.code === 1000) {
          this.jobs = res.data.jobs || [];
          this.jobsTotal = res.data.total || 0;
          // 检查如果所有职位 全部根据求职意向匹配，卡片则不展示标签
          this.checkJobs(this.jobs)
        }
        this.isUpdateJobs = false
      } catch (error) {
        console.log(error)
        this.isUpdateJobs = false
      }

    },
    async getRecommendList () {
	    try {
        let res = await api.recommend.cvsToJob({
          size: 6,
          page: 1,
          resume_token: this.onlineCv.resume ? this.onlineCv.resume.token : this.onlineCv.token ? this.onlineCv.token : null,
          is_pc: true
        });
        this.getJobLoading = false
        this.getJobEnd = true
        if (res.code === 1000) {
          this.jobs = res.data.jobs || [];
          this.jobsTotal = res.data.total || 0;
          // 检查如果所有职位 全部根据求职意向匹配，卡片则不展示标签
          this.checkJobs(this.jobs)
        }
      } catch (error) {
        this.getJobLoading = false
        this.getJobEnd = true
      }
    },
    // 会员过期设置在线简历
    setEditCvAfterMemberOver() {
      if (this._c_t) {
        let isMemberOver = this.cvs.every(item => !item.can_editable)
        if (isMemberOver && this.onlineCvIndex > -1 && this.cvIsRecommend) {
          api.cvsV3.editableCv({
            lang: 'cn',
            token: this.cvs[this.onlineCvIndex].token
          }).then(res => {
            if (res.code === 1000) {
              this.$store.dispatch('cv/getCvsList');
              // this.cvs[this.onlineCvIndex].can_editable = true
            }
          })
        }
      }
    },
    checkJobs (jobs) {
      this.is_all_intention = true
      this.is_one_intention = false
      if (jobs.length === 0) return false
      jobs.forEach( item => {
        if (item.recommend_source !== '1' && !(item.recommend_source === '2' && item.recommend_type === '3' && item.match_score < 50)) {
          this.is_all_intention = false
        }
        if (item.recommend_source === '1' || (item.recommend_source === '2' && item.recommend_type === '3' && item.match_score < 50)) {
          // 存在按求职意向推荐的卡片
          this.is_one_intention = true
          // 拿到 推荐的求职意向值
          // let level1 = item.expect_job_title.level1_names
          // if (level1 && level1.length > 0) {
          //   this.intentionText = level1[0]
          // }
        }
      })
    },
    async getData(type) {
      await this.$store.dispatch('cv/getCvsList');
      this._c_t = get_tUser().c_t || '';
      // 获取在线简历
      await this.getOnlineCv();
      this.isLoaderOnline = true;
      // 获取完草稿简历和在线简历之后
      this.isLoaderCv = true;
      // await this.$nextTick(() => {
      //   setTimeout(() => {
      //     this.isLoaderOnline = true;
      //   }, 1000);
      // })
      // 获取草稿简历
      // await this.$store.dispatch('cvs/getCvs');
      // this.isLoader = true;
      // 获取是否续费
      this.available();
      mainLoading.close();
      // 判断简历是否可更新
      setTimeout(() => {
        let cvs = this.cvs;
        // 没有草稿简历 直接 return 不执行
        if (!cvs.length) {
          this.isUpdated = false;
          this.newestCvToken = null
          return
        }

        // （新）有在线简历 则找到对应草稿简历 判断时间 是否要显示更新按钮
        if (this.onlineCv && this.onlineCv.resume && this.onlineCv.resume.token) {
          this.isUpdated = new Date(this.cvs[this.onlineCvIndex].update_time).getTime() - 1000 > new Date(this.onlineCv.resume.updated_at || '').getTime()
        // 没有在线简历 不显示更新按钮
        } else {
          this.isUpdated = false
        }

        // （旧）判断草稿简历列表里是否有更新时间大于当前在线简历的草稿简历
        // for (let i = 0; i < cvs.length; i++) {
        //   // 判断是否有最近更新的简历
        //   let isTrue = cvs[i].lang === 'cn'
        //     && !cvs[i].is_mentor
        //     && cvs[i].can_editable
        //     && new Date(cvs[i].update_time).getTime() - 1000 > (this.cv_invisibile ? new Date(this.updated_at).getTime() : new Date(this.onlineCv.resume && this.onlineCv.resume.updated_at || '').getTime());
        //   if (isTrue) {
        //     this.isUpdated = true;
        //     break;
        //   } else {
        //     this.isUpdated = false;
        //   }
        // }

        // 有效的简历
        let effectiveCv = []
        for (let i = 0; i < cvs.length; i++) {
          if (!cvs[i].is_mentor && cvs[i].lang === 'cn' && cvs[i].can_editable) {
            // 拿到可以成为在线简历的可用简历列表
            effectiveCv.push(cvs[i])
          }
        }

        // 拿到最近更新的简历 token
        if (effectiveCv.length) {
          effectiveCv.sort(function (a, b) {
            return new Date(b.update_time).getTime() - new Date(a.update_time).getTime()
          })
          this.newestCvToken = effectiveCv[0].token
        } else {
          this.newestCvToken = null
        }

        if (type === 'second') {

        } else {
          this.initJobscanAndPlanEntry()
        }

      }, 100);
    },
    async available() {
      let personInfo = this.personInfo;
      let cvs = this.cvs;
      let cvsEn = [];
      let cvsCn = [];
      let cvsEnDis = 0;
      let cvsCnDis = 0;
      if (!cvs.length) {
        return false;
      }
      for (let i = 0; i < cvs.length; i++) {
        if (cvs[i].lang === 'cn') {
          cvsCn.push(cvs[i]);
          if (cvs[i].can_editable) cvsCnDis++;
        }
        else {
          cvsEn.push(cvs[i]);
          if (cvs[i].can_editable) cvsEnDis++;
        }
      }
      this.isShowMember = !personInfo.is_membership && cvs.length && cvsEnDis === 0 && cvsCnDis === 0;
    },
    // toJobs
    toJobs(position) {
      
      if (this.cvsContentTabType === 'campus') {
        routerTo(`/campus_recruiting/user_show`, '_blank')
      }
      if (this.cvsContentTabType === 'job') {
        routerTo(`/jobs/search`, '_blank')
      }
    },

    // 导师辅导
    async perfectUrl() {
      let { count, first_order_token } = this.notSelectedMentorOrders;
      if(count>1){
        routerTo('/account/users?index=3');
      }else{
        routerTo(`/service/pay_success/${ first_order_token }?source=cv`);
      }
      // let cvsData = this.cvsData;
      // if (this.cvsData.mentor_order_url === 'multiple') {
      //   routerTo('/account/orders');
      // } else {
      //   routerTo(`/service/pay_success/${ cvsData.mentor_order_token }?source=cv`);
      // }
    },
    // 会员续费
    async member() {
      // let res = await api.cvsV2.membershipOrder({
      //   from_vue: 'true',
      //   improved_order: { package: 'membership' }
      // });
      routerTo(`/account/users/buy_member`);
    },
    setting() {
      routerTo('/account/users?index=2');
    },
    uplineClick() {
      this.showCvResume = true;
    },
    // 获取简历是否可以生成在线简历
    getisOnlineCv() {
      let isTrue = false;
      let cvs = this.cvs;
      for (let i = 0; i < cvs.length; i++) {
        if (cvs[i].lang === 'cn' && cvs[i].can_editable && !cvs[i].is_mentor) {
          isTrue = true;
          break;
        }
      }
      return isTrue;
    },
    // 获取求职意向
    async getIntention() {
      api.recruit.jobIntention({"platform": 'pc'}).then(res=>{
        if(res.code === 1000){
          this.intentionText = res.data.professions.join('、')
        }
      })
    },
    alertClose() {
      this.alertData.show = false;
      this.updateLoading = false
      setTimeout(async () => {
        await this.getData('second');
        // this.getRecommendList()
      }, 100);
    },
    upSetting() {
      if (this.cv_invisibile) {
        const alertData = {
          show: true,
          type: 'message',
          messageTitle: '',
          showCancelButton: true, //取消按钮
          showConfirmButton: true, // 确定按钮
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'cvs-edit-cancelButtonClass',
          cancelButtonClass: 'cvs-edit-confirmButtonClass',
          messageContent: `
            <p>更新简历后，简历将推荐给 HR</p>
            <p style="">确认更新？</p>
          `,
          cancel: close => {
            close();
          },
          confirm: async close => {
            close();
            // if (this.isPerfect) {
            // 	this.perfect()
            // } else {
            	this.createdSettingCv();
            // }
          }
        };
        this.$store.dispatch('app/setAlertData', alertData);
      } else {
        this.createdSettingCv('updated');
      }
    },
    // 创建简历的设置方法
    async createdSettingCv(type) {
      // 判断
      if (type === 'updated') {
        let cv = [];
        let cvs = this.cvs;
        if(this.updateLoading){
          return
        }
        this.updateLoading = true;
        for (let i = 0; i < cvs.length; i++) {
          if (!cvs[i].is_mentor && cvs[i].lang === 'cn' && cvs[i].can_editable) {
            // 拿到可以成为在线简历的可用简历列表
            cv.push(cvs[i]);
          }
        }
        if (cv.length === 1) {
          let res = await api.cvsV2.checkCv(cv[0].token);
          if (res.data.name_valid && res.data.contact_valid && res.data.gender_valid && res.data.edu_valid && res.data.work_valid) {
            let res = await api.cvsV2.createdOnlineCv({ token: cv[0].token });
            this.updateLoading = false
            if (res.code === 1000) {
              this.$message.success('更新成功');
              // this.getRecommendList()
              this.alertClose();
              return false;
            } else {
              this.$message.error('更新失败');
              return false;
            }
          }
        }
      }
      this.updatedType = type === 'new' ? 'new' : 'updated';
      // 判断用户身份
      let res = await api.me.getUserInfo(get_tUser().c_t);
      if (res.code !== 1000) {
        this.$message.error('网络出错，请重试');
        return false;
      }
      // 身份
	    // 求职意向
      if (!res.data.match) {
        this.alertData = {
          show: true,
          type: 'identity'
        }
        return false;
      } else if (!res.data.intention) {
        this.alertData = {
          show: true,
          type: 'intention'
        };
        return false;
      } else {
        // 拿到可以用的简历列表
      	const cnList = this.cvs.filter(item => !item.is_mentor && item.lang === 'cn' && item.can_editable)
      	if (cnList.length === 1) {
          this.perfect()
        } else {
		      this.alertData = {
			      show: true,
			      type: 'onLine'
		      };
        }
      }
    },
    // 获取在线简历
    async getOnlineCv() {
      let res = await api.cvsV2.cvVisibility(this._c_t);
      this.cv_invisibile = res.data && res.data.cv_invisibile || false;
      res = await api.cvsV2.getOnlineCv(this._c_t);
      if (res.code === 1000) this.cvIsRecommend = true

      let onlineCv = res.data && res.data.resume || res.data || {};
      // 检测在线简历，是否在简历列表数据中存在
      if(onlineCv.resume){
        let doesItExist =  this.cvs.findIndex(item=>{
          return item.token === onlineCv.resume.token
        })
        if(doesItExist<0){
          onlineCv = {}
        } else {
          this.onlineCvIndex = doesItExist
        }
      }
      this.onlineCv = onlineCv
      this.onlineCvDetailKey++
      this.updated_at = res.data && res.data.updated_at || '';
      this.checkCv();
    },
    // 判断简历完整度
    async checkCv() {
	    const list = this.cvs.filter(item => !item.is_mentor && item.lang === 'cn' && item.can_editable)
      let token = this.onlineCv.resume ? this.onlineCv.resume.token : this.onlineCv.token
	    // const token = list.length && list[0].token
      if (token && list.find(item => item.token === token)) {
	      let res = await api.cvsV2.checkCv(token);
	      let cvCheck = res.data || {};
	      this.isPerfect = !(cvCheck.name_valid && cvCheck.contact_valid && cvCheck.gender_valid && cvCheck.edu_valid && cvCheck.work_valid);
      }
    },
    // 完善
    async perfect() {
	    const list = this.cvs.filter(item => !item.is_mentor && item.lang === 'cn' && item.can_editable)
	    const token = list.length && list[0].token
      this.alertData = {
        show: true,
        type: 'onLine',
        showType: 'perfect',
        cv: {
          token
        }
      };
    },
    // 下载简历
    async download(data) {
      if (this.isDownloadCv) {
        return false;
      }
      this.isDownloadCv = true;
      let downloadLoading =  this.$message({
        message: '正在下载',
        iconClass:'el-icon-loading',
        duration:0,
      });
      let res = await api.cvsEditor.downloadCv(data.token, {watermark: 'no'});
      if (res.code !== 1000) {
        this.$message.error('下载失败');
        this.isDownloadCv = false;
        downloadLoading.close();
        return false;
      }
      axios({
        url: res.data.url,
        method: 'get',
        responseType: 'blob'
      })
      .then(r => {
        downloadjs(r.data, data.name || data.cv_name, "text/plain");
        this.isDownloadCv = false;
        downloadLoading.close();
        this.$message.success('下载成功');
      })
      .catch(err => {
        this.isDownloadCv = false;
        downloadLoading.close();
        this.$message.error('下载失败');
      })
    },
    // 判断是否有完善信息的导师订单
    getNotSelectedMentorOrders(){
      api.mentorOrders.getNotSelectedMentorOrders().then(res=>{
        if(res.code === 1000){
          this.notSelectedMentorOrders = res.data;
        }
      });
    },
  },
}
</script>
<style lang="scss" scoped>
  .cvs-main {

    .entry-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #f5f5f7;
      margin-bottom: 16px;
      cursor: pointer;

      .header-banner-item {
        flex: 1;
        display: flex;
        align-items: center;
        max-height: 135px;
        overflow: hidden;
        border-radius: 6px;
        &:nth-child(2) {
          margin-left: 16px;
        }
        img {
          width: 100%;
          object-fit: cover;
        }
      }

      .entry-item {
        flex: 1;
        padding: 10px 20px 20px;
        box-sizing: border-box;
        background: #ffffff;
        margin-right: 16px;
        box-shadow: 0px 1px 6px 0px rgba(3, 47, 129, 0.03);
        border-radius: 6px;

        &:hover {
          box-shadow: 0px 1px 18px 0px rgba(3, 47, 129, 0.12);
        }

        &:last-of-type {
          margin-right: 0;
        }

        &.jobscan {
          .entry-item-info.score {

            >div {
              font-size: 12px;
              font-weight: 400;
              color: #FF6644;
              line-height: 12px;
              margin-bottom: 6px;

              >span {
                font-size: 28px;
                font-weight: 500;
                color: #FF6644;
                line-height: 28px;
                max-width: 240px;
              }
            }
          }
        }

        &.plan {
          .entry-item-info>span {
            color: #4183FF !important;
          }
          .entry-item-info.name>span {
            color: #4183FF !important;
          }
        }

        .entry-item-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-bottom: 10px;
          border-bottom: 1px solid #F9F9F9;

          >div {
            display: flex;
            align-items: center;

            .entry-item-icon {
              width: 20px;
              height: 20px;
              object-fit: cover;
              object-position: center;
              margin-right: 10px;
            }

            .entry-item-title {
              font-size: 14px;
              font-weight: 400;
              color: #404040;
              line-height: 14px;
            }
          }

          .entry-item-btn {
            width: 76px;
            height: 24px;
            border-radius: 12px;
            border: 1px solid #ECECEC;
            padding: 0;
            box-sizing: border-box;
            background: #ffffff;
            font-size: 13px;
            font-weight: 400;
            color: #606060;

            &:hover {
              opacity: 0.8;
            }

          }
        }

        .entry-item-content {
          display: flex;
          align-items: center;
          padding-top: 16px;

          .entry-item-image {
            width: 54px;
            height: 54px;
            object-fit: cover;
            object-position: center;
            margin-right: 20px;
          }

          .entry-item-info {

            >span {
              display: block;
              font-size: 18px;
              font-weight: 500;
              color: #FF6644;
              line-height: 20px;
              margin-bottom: 10px;
              max-width: 260px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            >p {
              font-size: 14px;
              font-weight: 400;
              color: #606060;
              line-height: 14px;
              max-width: 260px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }

        }

      }

    }

    .recruit {
      display: flex;
      margin-bottom: 24px;
      justify-content: space-between;
      .recruit-item {
        width: 226px;
        height: 168px;
        background: #FFFFFF;
        border-radius: 6px;
        img {
          border-radius: 6px 6px 0 0;
          width: 226px;
          height: 120px;
        }
        .recruit-item-msg {
          text-align: center;
          line-height: 48px;
          font-weight: 400;
          color: #404040;
          font-size: 14px;
        }
      }
      .recruit-entrance {
        img {
          width: 173px;
          height: 168px;
        }
      }
    }
    .download-resume {
      width: 0;
      height: 0;
      position: flxed;
      top: 0;
      left: 0;
      overflow: hidden;
    }
    /*margin-top: 80px;*/
    .margin-b-1 {
      margin-bottom: 1px;
    }
    .margin-b-24 {
      margin-bottom: 24px;
    }

    .on-line {
      .title {
        display: flex;
        justify-content: space-between;

        .title-setting {
          display: flex;
          align-items: center;
          font-size: 14px;
          font-weight: 400;
          color: #9C9C9C;
          cursor: pointer;

          >img {
            width: 16px;
            height: 16px;
            margin-left: 6px;
          }
        }
      }
    }

    .title {
      width: 100%;
      height: 54px;
      line-height: 54px;
      padding: 0 32px;
      background: #fff;
      color: #404040;
      font-size: 14px;
      font-weight: 700;
      box-sizing: border-box;
      border-radius: 4px 4px 0 0;
      span {
        color: #9C9C9C;
        margin-left: 14px;
        font-weight: 400;
      }
      .title-right {
        float: right;
        color: #909090;
        font-size: 14px;
        display: flex;
        align-items: center;
        &.active {
          .iconfont {
            transform: rotate(180deg);
          }
        }
        .iconfont {
          display: block;
          margin-left: 6px;
          transform-origin: 50% 50%;
          transition: all .3s ease;
        }
      }
    }
    .setting {
      width: 100%;
      padding: 0 32px;
      background: #57596C;
      color: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 24px;
      border-radius: 4px;
      .text {
        font-size: 14px;
        font-weight: 400;
      }
      .iconfont {
        margin-right: 8px;
      }
      button {
        width: 100px;
        height: 32px;
        border-radius: 16px;
        background: #fff;
        color: #57596C;
        font-size: 14px;
        &:last-child {
          margin-left: 16px;
        }
        &:hover {
          color: #7E8099;
        }
      }
      &.hint {
        background:rgba(255,79,76,0.09);
        color: #FF4F4C;
        margin-bottom: 0;
        border-radius: 4px 4px 0 0;
        button {
          background: #FF4F4C;
          color: #fff;
        }
      }
    }
    .cvs-job {
      background: #fff;
      border-radius: 6px;
      overflow: hidden;
      box-shadow: 0px 1px 6px 0px rgba(3, 47, 129, 0.03);
      .cvs-job-title {
        display: flex;
        justify-content: space-between;
        position: relative;
        padding: 24px 0 10px;
        margin-left: 24px;
        margin-right: 24px;
        border-bottom: 1px solid #f9f9f9;
        margin-bottom: 16px;

        // &.tab1::after {
        //   left: 45px;
        // }

        // &.tab2::after {
        //   left: 125px;
        // }

        // &.tab3::after {
        //   left: 210px;
        // }

        // &::after {
        //   content: "";
        //   position: absolute;
        //   left: 0px;
        //   bottom: 0px;
        //   width: 12px;
        //   height: 2px;
        //   background: #FF6644;
        //   border-radius: 1px;
        //   transition: left 0.4s ease;
        // }

        .cvs-job-title-left {

          >span {
            position: relative;
            display: inline-block;
            font-size: 14px;
            font-weight: 500;
            color: #9C9C9C;
            line-height: 14px;
            margin-right: 24px;
            cursor: pointer;
            line-height: 14px;

            &.new {
              i {
                display: inline-block;
                width: 15px;
                height: 15px;
                background: #FF4F4C;
                border-radius: 50%;
                text-align: center;
                line-height: 15px;
                font-size: 12px;
                font-weight: 500;
                color: #FFFFFF;
                box-sizing: border-box;
              }
            }

            >i {
              font-style: inherit;
            }

            &:last-of-type {
              margin-right: 0;
            }

            &.active {
              color: #404040;

              &::after {
                content: "";
                position: absolute;
                left: 50%;
                bottom: -11px;
                transform: translateX(-50%);
                width: 12px;
                height: 2px;
                background: #FF6644;
                border-radius: 1px;
              }
            }

          }
        }

        .cvs-job-title-right {
          cursor: pointer;

          &:hover {
            opacity: 0.8;
          }

          >span {
            font-size: 14px;
            font-weight: 400;
            color: #606060;
            line-height: 14px;
          }

          >i {
            color: #959595;
            font-size: 14px;
            font-weight: 600;
          }
        }


      }
      .cvs-job-setting {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        padding: 0 32px;
        margin-bottom: 20px;
        .setting-desc {
          display: inline-block;
          color: #9C9C9C;
          margin-right: 16px;
        }
        .setting-button {
          color: #FF6644;
          cursor: pointer;
        }
      }
      .cvs-job-list {
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 0 24px;
        .item-card {
          margin-bottom: 15px;
          // &:nth-child(5),
          // &:nth-child(6) {
          //   margin-bottom: 0;
          // }
        }
      }
      .cvs-job-more {
        display: block;
        width: 240px;
        height: 40px;
        border: 1px solid #ff6644;
        color: #ff6644;
        font-size: 14px;
        border-radius: 6px;
        margin: 9px auto 24px;
        background: #ffffff;
        &:hover {
          color: #ffffff;
          background: #ff6644;
        }
      }
      .campus-list {
        padding: 0 24px;
        box-sizing: border-box;
      }
    }
    .drafts{
      border-radius: 4px;
      overflow: hidden;
    }
    .drafts-list {
      &.drafts-list-hidden {
        height: 170px;
        overflow: hidden;
      }
    }
    .drafts-more {
      padding: 16px 0;
      text-align: center;
      font-size: 14px;
      color: #909090;
      background: #fff;
      &:hover {
        color: #4183FF;
        .iconfont {
          color: #4183FF;
        }
      }
      span {
        cursor: pointer;
      }
      .iconfont {
        display: inline-block;
        margin-left: 4px;
        transform-origin: 50% 50%;
        transition: all .3s ease;
      }
      .active .iconfont {
        transform: rotate(180deg);
      }
      .blue {
        color: #4183FF;
      }
    }
    .banner-carousel {
      width: 100%;
      margin-top: 24px;
      border-radius: 2px;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }
  .download-app-chat {
    ::v-deep .w-dialog-content {
      top: 80px !important;
      left: 50%;
      margin-left: -170px;
    }
  }
  .popup-banner-container {
    position: fixed;
    bottom: 50%;
    right: 30px;
    transform: translateY(50%);
    border-radius: 7px;
    box-shadow: -2px 15px 25px 0px rgba(46,66,104,0.12);
    cursor: pointer;
    //overflow: hidden;
    img {
      width: 100px;
			object-fit: contain;
    }
    .close-btn {
      width: 15px;
      height: 15px;
      position: absolute;
      top: -20px;
      right: 0px;
      background-color: rgba(0, 0, 0, .2);
      border-radius: 50%;
      transition: all .5s;
      &:hover {
        transform: rotate(180deg) scale(1.2);
      }
      &:before {
        content: '';
        display: block;
        width: 70%;
        height: 2px;
        background-color: rgba(255, 255, 255, .5);
        border-radius: 1px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%) rotate(45deg);
      }
      &:after {
        content: '';
        display: block;
        width: 2px;
        height: 70%;
        background-color: rgba(255, 255, 255, .5);
        border-radius: 1px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%) rotate(45deg);
      }
    }
  }
</style>
<style lang="scss">
  // 设置此页面删除弹框按钮样式
.cvs-edit-cancelButtonClass {
  background: #FF6644 !important;
  color: #fff !important;
  border-color: #FF6644 !important;
}
.cvs-edit-confirmButtonClass {
  background: #fff !important;
  color: #606060 !important;
  border-color: #D9D9D9 !important;
}
</style>
